import React, { useMemo } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import { getMonthOptions } from '../Utilities/dateUtility';

interface ForecastViewModel {
    forecastId: number;
    name: string;
    startPeriod: number;
    startDate: string;
    forecastPeriods: any[];
}

interface MonthDropdownProps {
    selectedForecast?: ForecastViewModel | null;
    selectedMonth: string | null;
    onMonthSelected: (month: string | null) => void;
    disabled?: boolean;
}

const MonthDropdown: React.FC<MonthDropdownProps> = ({ 
    selectedForecast, 
    selectedMonth, 
    onMonthSelected,
    disabled = false
}) => {
    const monthOptions = useMemo(() => {
        if (!selectedForecast?.startDate || isNaN(new Date(selectedForecast.startDate).getTime())) {
            const today = new Date();
            const startDate = new Date(today.getFullYear(), 0, 1);
            const endDate = new Date(today.getFullYear(), 11, 31);
            return getMonthOptions(startDate, endDate);
        }

        const forecastStartDate = new Date(selectedForecast.startDate);
        const startMonth = new Date(forecastStartDate.getFullYear(), forecastStartDate.getMonth(), 1);
        const twelveMonthsAfterStart = new Date(startMonth.getFullYear(), startMonth.getMonth() + 12, 0); // Last day of 12th month
        
        return getMonthOptions(startMonth, twelveMonthsAfterStart);
    }, [selectedForecast]);
    
    const selectedValue = monthOptions.find(
        option => option.value === selectedMonth
    ) || null;

    const handleMonthChange = (event: React.SyntheticEvent, value: { value: string; label: string } | null) => {
        onMonthSelected(value ? value.value : null);
    };

    return (
        <Autocomplete
            disablePortal
            disabled={disabled}
            id="combo-box-month"
            options={monthOptions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            sx={{ width: 300 }}
            value={selectedValue}
            onChange={handleMonthChange}
            renderOption={(props, option) => (
                <Box
                    component="li"
                    {...props}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <span>{option.label}</span>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Month"
                />
            )}
        />
    );
};

export default MonthDropdown; 